import React, { useEffect, useCallback, useRef } from "react";
import { Fade, LinearProgress } from "@material-ui/core";

import { useGlobalError } from "../../features/ErrorModal";
import { useConfigContext } from "../../features/Auth";
import { useTokenExpiry } from "../../features/Auth/hooks/useTokenExpiry";
import { ErrorLevel } from "../../features/ErrorModal/ErrorProvider";

export const AppGate: React.FC = ({ children }) => {
  useTokenExpiry();

  const isUnmounting = useRef(false);

  const { error: globalError, setError } = useGlobalError();
  const { error: configError, loading } = useConfigContext();

  const onClearError = useCallback(() => {
    // set unmount so the error dialog wont show up again before window is reloaded
    isUnmounting.current = true;
    window.location.reload();
  }, []);

  useEffect(() => {
    if (!isUnmounting.current && !globalError && configError) {
      setError({
        title: "Failed to load application",
        message: configError.message,
        handlerText: "Try again",
        level: ErrorLevel.Error,
        onClearError,
      });
    }
  }, [configError, globalError, onClearError, setError]);

  return isUnmounting.current || loading ? (
    <Fade in={true} unmountOnExit>
      <LinearProgress />
    </Fade>
  ) : !configError ? (
    <>{children}</>
  ) : null;
};
